<div>
  <section>
    <form>
      <div class="row">
        <div class="col">
          <div class="inner-box">
            <h2>Set An Eligibility Frame</h2>
            <div class="row mt-3">
              <div class="col-md-8">
                <div>
                  Items must be returned within the timeline established by you. Please note that time period begins when
                  Customer places order, not when Customer receives order.
                  <div class="mt-3">
                    <div class="form-group">
                      <label class="control-label" for="days">Days</label>
                      <input type="text" id="days" [(ngModel)]="day.config"
                             onkeypress='return event.charCode >= 48 && event.charCode <= 57' class="form-control"
                             [ngModelOptions]="{standalone: true}" requiredclass="form-control" maxlength="2" min="0"
                             max="60" required>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-lg-12">
          <div class="inner-box">
            <h2>Reason For Product Return</h2>
            <div class="row mt-3">
              <div class="col">
                <table class="table table-stripe">
                  <thead>
                  <tr>
                    <th class="w-25 p-l-0">Reason</th>
                    <th class="w-25">Action</th>
                  </tr>

                  <tr>
                    <td> <input type="text" id="config" [(ngModel)]="config" class="form-control"
                        (blur)="typeReason()" [ngClass]="{'is-invalid':statusText1}"   [ngModelOptions]="{standalone: true}" required></td>
                    <td>
                      <a (click)="submitReturn()" data-toggle="modal" class="p-2 ml-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21.34 21.34">
                          <defs><style>.ab{fill:#ee7125;}</style></defs>
                          <path class="ab" d="M14.045,3.375a10.67,10.67,0,1,0,10.67,10.67A10.67,10.67,0,0,0,14.045,3.375Zm5.489,11.747H15.122v4.412H12.968V15.122H8.556V12.968h4.412V8.556h2.155v4.412h4.412Z" transform="translate(-3.375 -3.375)"/>
                        </svg>
                      </a>
                    </td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor="let r of reasonList">
                    <td class="p-l-0">{{r.config}}</td>
                    <td>
                      <a data-toggle="modal" data-target="#deleteReturnModal1" (click)="selectedDeleteReturn(r)"
                         class="p-2 ml-3">
                        <svg xmlns="http://www.w3.org/2000/svg" height="21" viewBox="0 0 18.877 24.27">
                          <defs><style>.a{fill:#848484;}</style></defs>
                          <path class="a" d="M8.848,26.073a2.7,2.7,0,0,0,2.7,2.7H22.332a2.7,2.7,0,0,0,2.7-2.7V9.893H8.848Zm3.317-9.6,1.9-1.9,2.872,2.858L19.8,14.572l1.9,1.9L18.84,19.332,21.7,22.19l-1.9,1.9-2.858-2.858L14.08,24.091l-1.9-1.9,2.858-2.858ZM21.658,5.848,20.309,4.5H13.568L12.219,5.848H7.5v2.7H26.377v-2.7Z" transform="translate(-7.5 -4.5)"/>
                        </svg>
                      </a>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <div id="statusText1" class="invalid-feedback d-block shift-invalid-login mt-2"
                     [hidden]="!statusText1">{{statusText1}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col">
          <div class="inner-box">
            <h2>Non Returnable Items</h2>
            <div class="row mt-3">
              <div class="col">
                <table class="table table-stripe">
                  <thead>
                  <tr>
                    <th class="w-25 p-l-0">Product Name</th>
                    <th class="w-25">Action</th>
                  </tr>
                  <tr>
                    <td>
                      <div class="form-group mb-2 ware-house">
                        <ng-select id="product" [(ngModel)]="activeProduct"
                                   [ngClass]="{'service-error':statusText2}" (blur)="selectProduct()"
                                   [ngModelOptions]="{standalone: true}" required
                                   [items]="activeProducts"
                                   bindLabel="productName"
                                   placeholder="Products">
                        </ng-select>
                      </div>
                    </td>
                    <td>
                      <a data-toggle="modal" (click)="submitProduct()" class="p-2 ml-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21.34 21.34">
                          <defs><style>.ab{fill:#ee7125;}</style></defs>
                          <path class="ab" d="M14.045,3.375a10.67,10.67,0,1,0,10.67,10.67A10.67,10.67,0,0,0,14.045,3.375Zm5.489,11.747H15.122v4.412H12.968V15.122H8.556V12.968h4.412V8.556h2.155v4.412h4.412Z" transform="translate(-3.375 -3.375)"/>
                        </svg>
                      </a>
                    </td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor="let rp of returnProducts">
                    <td class="p-l-0">{{rp.productName}}</td>
                    <td>
                      <a data-toggle="modal" data-target="#deleteReturnModal2" (click)="selectedDeleteProduct(rp)"
                         class="p-2 ml-3">
                        <svg xmlns="http://www.w3.org/2000/svg" height="21" viewBox="0 0 18.877 24.27">
                          <defs><style>.a{fill:#848484;}</style></defs>
                          <path class="a" d="M8.848,26.073a2.7,2.7,0,0,0,2.7,2.7H22.332a2.7,2.7,0,0,0,2.7-2.7V9.893H8.848Zm3.317-9.6,1.9-1.9,2.872,2.858L19.8,14.572l1.9,1.9L18.84,19.332,21.7,22.19l-1.9,1.9-2.858-2.858L14.08,24.091l-1.9-1.9,2.858-2.858ZM21.658,5.848,20.309,4.5H13.568L12.219,5.848H7.5v2.7H26.377v-2.7Z" transform="translate(-7.5 -4.5)"/>
                        </svg>
                      </a>
                    </td>
                  </tr>
                  <div id="statusText2" class="invalid-feedback d-block shift-invalid-login mt-2"
                       [hidden]="!statusText2">{{statusText2}}</div>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="form-btn-section">
          <div class="row">
            <div class="col-12 text-right">
              <button type="submit" (click)="submitDay(day)" class="btn btn-orange ml-2">Save</button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </section>

  <!--Delete model-box One-->
  <div class="container">
    <div class="modal fade" id="deleteReturnModal1" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Delete</h4>
            <button type="button" class="close" data-dismiss="modal">&times;</button>
          </div>
          <div class="modal-body">
            <p>Do you really want to delete </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-delete" data-dismiss="modal">No</button>
            <button type="button" class="btn btn-edit" data-dismiss="modal" (click)="deleteReturn()">Yes</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--Delete model-box two-->
  <div class="container">
    <div class="modal fade" id="deleteReturnModal2" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Delete</h4>
            <button type="button" class="close" data-dismiss="modal">&times;</button>
          </div>
          <div class="modal-body">
            <p>Do you really want to delete </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-delete" data-dismiss="modal">No</button>
            <button type="button" class="btn btn-edit" data-dismiss="modal" (click)="deleteReturnProduct()">Yes</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="form-btn-section" style="margin-left: -30px;">
  <div class="row">
    <div class="col-12 text-right">
      <button type="submit" (click)="submitDay(day)" class="btn btn-orange ml-2">Save</button>
    </div>
  </div>
</div>
